
import Breadcrumbs from '~/components/moleculus/Breadcrumbs.vue'

export default {
  name: 'RPHAnalogsPage',
  middleware: ['redirectOnFirstPage'],
  components: {
    Breadcrumbs,
    RPHAnalogs: () => import('rph/templates/RPHAnalogs/index.vue'),
  },
  async asyncData({ params, $repositories, query, store }) {
    const slug = params.slug
    let analogInfo
    let analogs
    let meta
    try {
      const analogsResponse = await store.dispatch('rph-products/getProductAnalogs', {
        slug: slug,
        params: {
          params: {
            expand: 'products,inns',
            'filter[sort_stock]': query.availability,
            'filter[sort_price][gte]': query.price_from,
            'filter[sort_price][lte]': query.price_to,
            'filter[form_id]': query.form,
            'filter[dosage]': query.dosage,
            'filter[sale_amount]': query.discount,
            sort: query.sort,
            page: query.page,
            'per-page': 12,
          },
        },
      })

      analogInfo = {
        title: analogsResponse.title,
        inns: analogsResponse.inns,
      }

      analogs = analogsResponse.products.items
      meta = analogsResponse.products.product_meta
    } catch (error) {
      console.log(error)
    }

    return { analogInfo, analogs, meta }
  },
  watchQuery(newQuery, oldQuery) {
    return !(newQuery.view !== oldQuery.view)
  },
  computed: {
    isFirstPage() {
      return this.$route.query.page === '1' || !this.$route.query.page
    },
    structuredData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'OfferCatalog ',
        name: this.seo?.title,
        description: this.seo?.description,
        itemListElement: this.analogs?.data?.map((product) => {
          return {
            '@type': 'Offer',
            url: `https://aurma.kz/${product?.slug}`,
            name: product?.title,
            image: product.images[0]?.links?.medium,
          }
        }),
      }
    },
    breadCrumbs() {
      const { title, slug } = this.analogInfo
      return this.$services.breadcrumbs.createCrumbs([{ title: `Аналоги ${title}`, slug }])
    },
  },
  head() {
    let titleNumber =
      this.$route.query.page !== '1' && this.$route.query.page
        ? ` - страница ${this.$route.query.page}`
        : ''
    let descNumber =
      this.$route.query.page !== '1' && this.$route.query.page
        ? ` Cтраница ${this.$route.query.page}.`
        : ''
    return {
      title:
        (this.isFirstPage
          ? `Аналоги и заменители ${this.analogInfo.title}, купить в Алматы с доставкой`
          : `Аналоги ${this.analogInfo.title} в Алматы`) + `${titleNumber}`,
      meta: this.$services.head.createMeta({
        title:
          (this.isFirstPage
            ? `Аналоги и заменители ${this.analogInfo.title}, купить в Алматы с доставкой`
            : `Аналоги ${this.analogInfo.title} в Алматы`) + `${titleNumber}`,
        description:
          (this.isFirstPage
            ? `Все аналоги ${this.analogInfo.title} в аптеке. Список аналогов и заменителей для ${this.analogInfo.title}: наличие и цены в Алматы. Заказать аналоги ${this.analogInfo.title} с быстрой доставкой на дом.`
            : `Купить аналоги ${this.analogInfo.title} в Алматы с доставкой.`) + `${descNumber}`,
      }),
      script: [{ json: this.structuredData, type: 'application/ld+json' }],
      link: [
        this.$route.query.page &&
        new Set(Object.values(this.$route.query).filter((value) => value !== null)).size === 1
          ? this.$services.head.createCanonicalLink(
              `${this.$route.path}?page=${this.$route.query.page}`,
            )
          : this.$services.head.createCanonicalLink(this.$route.path),
      ],
    }
  },
}
